import iziToast from 'izitoast';

const iziResendInvoice = (message, onSMS, onEmail, onWhatsApp, onCancel) => {
  iziToast.question({
    timeout: false,
    close: false,
    overlay: true,
    displayMode: 'once',
    id: 'question',
    zindex: 999,
    title: '',
    message,
    position: 'center',
    progressBar: false,
    buttons: [
      [
        '<button>SMS</button>',
        (instance, toast) => {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          onSMS();
        },
        true,
      ],
      [
        '<button>WhatsApp</button>',
        (instance, toast) => {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          if (onWhatsApp) onWhatsApp();
        },
        false,
      ],
      [
        '<button>Email</button>',
        (instance, toast) => {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          onEmail();
        },
        false,
      ],
      [
        '<button>Cancel</button>',
        (instance, toast) => {
          instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          if (onCancel) onCancel();
        },
        false,
      ],
    ],
  });
};

export default iziResendInvoice;
